require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-life-as-a-door-host.json") })
        }
      }, "path---feature-life-as-a-door-host");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-life-as-a-door-host!./.cache/json/feature-life-as-a-door-host.json
// module id = 641
// module chunks = 231608221292675